<template>
    <!-- 遮罩层 -->
    <div class="message-box-overlay" v-if="visible">
        <!-- 弹窗容器 -->
        <div class="message-box" @click.stop>
            <!-- 头部 -->
            <div class="message-box-header">
                <div class="title">{{ title }}</div>
                <div class="close-btn" @click="handleClose">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 4L4 12M4 4L12 12" stroke="#499ddb" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>
            </div>

            <!-- 内容区域 -->
            <div class="message-box-body">
                <!-- 确认弹窗内容 -->
                <div v-if="type === 'confirm'" class="confirm-content">
                    {{ message }}
                </div>

                <!-- 输入弹窗内容 -->
                <div v-if="type === 'input'" class="input-content">
                    <textarea v-model="inputValue" :placeholder="placeholder" class="input-textarea" rows="4" @input="handleInput"></textarea>
                </div>
            </div>

            <!-- 底部按钮 -->
            <div class="message-box-footer">
                <button class="btn btn-cancel" @click="handleCancel">取消</button>
                <button class="btn btn-confirm" @click="handleConfirm">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MessageBox",
    data() {
        return {
            visible: false,
            type: "confirm", // 'confirm' | 'input'
            title: "提示",
            message: "",
            placeholder: "请输入内容",
            inputValue: ""
        }
    },
    methods: {
        // 显示确认弹窗
        showConfirm(options = {}) {
            this.type = "confirm"
            this.title = options.title || "提示"
            this.message = options.message || "是否确认？"
            this.visible = true
        },

        // 显示输入弹窗
        showInput(options = {}) {
            this.type = "input"
            this.title = options.title || "请输入"
            this.placeholder = options.placeholder || "请输入内容"
            this.inputValue = options.defaultValue || ""
            this.visible = true
        },

        // 处理输入
        handleInput(event) {
            this.inputValue = event.target.value
        },

        // 关闭弹窗
        handleClose() {
            this.visible = false
            this.resetData()
        },

        // 取消按钮
        handleCancel() {
            this.visible = false

            this.resetData()
        },

        // 确定按钮
        handleConfirm() {
            if (this.type == "confirm") {
                this.$emit("approve")
            } else if (this.type == "input") {
                this.$emit("reject", this.inputValue)
            }
            this.resetData()
            this.visible = false
        },

        // 重置数据
        resetData() {
            this.type = "confirm"
            this.title = "提示"
            this.message = ""
            this.placeholder = "请输入内容"
            this.inputValue = ""
        }
    }
}
</script>

<style lang="scss" scoped>
.message-box-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
    animation: fadeIn 0.3s ease-out;
}

.message-box {
    background: white;
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease-out;
    overflow: hidden;
}

.message-box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 20px 0 20px;

    .title {
        color: #499ddb;
        font-size: 25px;
        font-weight: bolder;
        flex: 1;
    }

    .close-btn {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;
        transition: background-color 0.2s;
        color: #499ddb;
        &:hover {
            background-color: #f5f5f5;
        }
    }
}

.message-box-body {
    padding: 20px;

    .confirm-content {
        font-size: 16px;
        line-height: 1.5;
        color: #666;
        text-align: left;
        font-weight: bolder;
    }

    .input-content {
        .input-textarea {
            width: 90%;
            min-height: 40px;
            padding: 12px;
            border: 2px solid #e5e5e5;
            border-radius: 8px;
            font-size: 16px;
            font-family: inherit;
            resize: none;
            outline: none;
            transition: border-color 0.2s;

            &:focus {
                border-color: #4a90e2;
            }

            &::placeholder {
                color: #999;
            }
        }
    }
}

.message-box-footer {
    display: flex;
    padding: 0 20px 20px 20px;
    gap: 12px;

    .btn {
        margin-top: 8px;
        flex: 1;
        height: 44px;
        border-radius: 8px;
        border: none;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        outline: none;

        &.btn-cancel {
            background-color: #f8f9fa;
            color: #666;
            border: 1px solid #e5e5e5;

            &:hover {
                background-color: #e9ecef;
            }

            &:active {
                transform: translateY(1px);
            }
        }

        &.btn-confirm {
            background-color: #4a90e2;
            color: white;

            &:hover {
                background-color: #357abd;
            }

            &:active {
                transform: translateY(1px);
                background-color: #2e6da4;
            }
        }
    }
}

// 动画效果
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 移动端响应式
@media (max-width: 480px) {
    .message-box-overlay {
        padding: 16px;
    }

    .message-box {
        max-width: 100%;
    }

    .message-box-header .title {
        font-size: 16px;
    }

    .message-box-body .confirm-content {
        font-size: 14px;
    }

    .message-box-footer .btn {
        height: 40px;
        font-size: 14px;
    }
}
</style>
